import _classCallCheck from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Signal } from "../../signal/Signal";
import { optionsFromArguments } from "../util/Defaults";
import { TickParam } from "./TickParam";
/**
 * TickSignal extends Tone.Signal, but adds the capability
 * to calculate the number of elapsed ticks. exponential and target curves
 * are approximated with multiple linear ramps.
 *
 * Thank you Bruno Dias, H. Sofia Pinto, and David M. Matos,
 * for your [WAC paper](https://smartech.gatech.edu/bitstream/handle/1853/54588/WAC2016-49.pdf)
 * describing integrating timing functions for tempo calculations.
 */

export var TickSignal = /*#__PURE__*/function (_Signal) {
  _inherits(TickSignal, _Signal);

  var _super = _createSuper(TickSignal);

  function TickSignal() {
    var _this;

    _classCallCheck(this, TickSignal);

    _this = _super.call(this, optionsFromArguments(TickSignal.getDefaults(), arguments, ["value"]));
    _this.name = "TickSignal";
    var options = optionsFromArguments(TickSignal.getDefaults(), arguments, ["value"]);
    _this.input = _this._param = new TickParam({
      context: _this.context,
      convert: options.convert,
      multiplier: options.multiplier,
      param: _this._constantSource.offset,
      units: options.units,
      value: options.value
    });
    return _this;
  }

  _createClass(TickSignal, [{
    key: "ticksToTime",
    value: function ticksToTime(ticks, when) {
      return this._param.ticksToTime(ticks, when);
    }
  }, {
    key: "timeToTicks",
    value: function timeToTicks(duration, when) {
      return this._param.timeToTicks(duration, when);
    }
  }, {
    key: "getTimeOfTick",
    value: function getTimeOfTick(tick) {
      return this._param.getTimeOfTick(tick);
    }
  }, {
    key: "getDurationOfTicks",
    value: function getDurationOfTicks(ticks, time) {
      return this._param.getDurationOfTicks(ticks, time);
    }
  }, {
    key: "getTicksAtTime",
    value: function getTicksAtTime(time) {
      return this._param.getTicksAtTime(time);
    }
    /**
     * A multiplier on the bpm value. Useful for setting a PPQ relative to the base frequency value.
     */

  }, {
    key: "multiplier",
    get: function get() {
      return this._param.multiplier;
    },
    set: function set(m) {
      this._param.multiplier = m;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(TickSignal.prototype), "dispose", this).call(this);

      this._param.dispose();

      return this;
    }
  }], [{
    key: "getDefaults",
    value: function getDefaults() {
      return Object.assign(Signal.getDefaults(), {
        multiplier: 1,
        units: "hertz",
        value: 1
      });
    }
  }]);

  return TickSignal;
}(Signal);